import useDurationLimitCheck from 'hooks/useDurationLimitCheck'
import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { dispatch } from 'store'
import { editorThunks } from 'store/features/editor/thunks'
import { projectDataSelectors } from 'store/features/projectData/selectors'
import { projectDataThunks } from 'store/features/projectData/thunks'
import { recentlyUsedMediaThunks } from 'store/features/recentlyUsedMedia/thunks'
import { IBaseMediaItem, MediaStatus } from 'types/media'
import { scrollToElementById } from 'utils'
import { convertBaseItemToMediaItem } from 'utils/media'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'
import { useResponsive } from './useResponsive'
import { useInsertionStartTime } from './timeline/useInsertionStartTime'
import { useTimelineContext } from 'context/TimelineContext'

export const useAddAiItemToTimeline = () => {
  const isTablet = useResponsive(SMALL_DESKTOP_SIZE_BREAKPOINT)
  const defaultDimensions = useSelector(projectDataSelectors.defaultDimensions)
  const { isDurationAllowed } = useDurationLimitCheck()
  const getInsertionStartTime = useInsertionStartTime()
  const { setPlayHeadCurrentTime, isPlaying } = useTimelineContext()

  return useCallback(
    (mediaItem: IBaseMediaItem) => {
      if (!isDurationAllowed(mediaItem.duration)) {
        return null
      }

      const insertionStartTime = getInsertionStartTime(mediaItem.duration)

      const preparedItem = convertBaseItemToMediaItem(
        mediaItem,
        insertionStartTime,
        defaultDimensions
      )

      dispatch(
        projectDataThunks.addMediaItems({
          value: [preparedItem],
          config: { applySelection: false, isUndoable: true }
        })
      )
      dispatch(
        editorThunks.setActiveTimelineItems([
          {
            id: preparedItem.id,
            type: preparedItem.type
          }
        ])
      )
      scrollToElementById(preparedItem.id)
      setPlayHeadCurrentTime(insertionStartTime, isPlaying)

      if (isTablet) {
        dispatch(editorThunks.setIsMobileSubSidebarOpen(false))
      }

      if (preparedItem.meta.status === MediaStatus.OK) {
        dispatch(
          recentlyUsedMediaThunks.updateRecentlyUsedItemsOnInsertFromMediaLibrary(
            [preparedItem]
          )
        )
      }
    },
    [
      defaultDimensions,
      isDurationAllowed,
      isTablet,
      getInsertionStartTime,
      isPlaying,
      setPlayHeadCurrentTime
    ]
  )
}
